import React, { memo, useState } from 'react';
import 'react-phone-number-input/style.css';
import styles from '../../assets/scss/design.scss';
import { useSelector } from 'react-redux';
import { CloseCircleFilled } from '@ant-design/icons';
import PhoneInput, { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';

function PhoneNumberInput(props) {
  const { setPhoneNumber, countryCode } = props;
  const [mobileNumber, setMobileNumber] = useState('');
  const [focused, setFocused] = useState(false);

  const utilities = useSelector((state) => state.utilities);

  const onChange = (value) => {
    setMobileNumber(value);
    if (value && value.length > 7 && isValidPhoneNumber(value)) {
      const phoneNumber = parsePhoneNumber(value);
      setPhoneNumber({
        number: phoneNumber.number,
        nationalNumber: phoneNumber.nationalNumber,
        country: phoneNumber.country,
        countryCallingCode: phoneNumber.countryCallingCode,
      });
    } else {
      setPhoneNumber('');
    }
  };

  const onFocus = () => {
    setFocused(true);
  };

  const onBlur = () => {
    setFocused(false);
  };

  const clearField = () => {
    setMobileNumber('');
    setPhoneNumber('');
  };

  return (
    <div className={styles.allow_clear}>
      <PhoneInput
        international
        countryCallingCodeEditable={false}
        defaultCountry={countryCode ? countryCode : utilities.currentCountry}
        placeholder='Your mobile number...'
        value={mobileNumber}
        limitMaxLength={true}
        className={focused ? 'focused' : null}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      {mobileNumber && mobileNumber.length >= 1 ? <CloseCircleFilled onClick={clearField} /> : null}
    </div>
  );
}

export default memo(PhoneNumberInput);
